import { createFileRoute } from "@tanstack/react-router";
import { CountryLayout } from "@/components/layout/CountryLayout";

export const Route = createFileRoute("/$country")({
  component: CountryLayout,
});
